<template>
	<FootprintTableSingleEdit />
</template>

<script>
import FootprintTableSingleEdit from '@/components/FootprintTable/FootprintTableSingle/FootprintTableSingleEdit'

export default {
	name: "FootprintPageSingle",
	components: {
		FootprintTableSingleEdit
	},
	mounted() {
	}
}
</script>

<style scoped>

</style>